import type { DocumentNode } from '@apollo/client/core';
import type { Maybe } from '@/helpers/types';

import { getAppVersion } from '@/graphql/utils/links';
import { getAxiosCached } from '@/helpers/axios-helper';
import { captureMessageForSentry } from '@/libraries/sentry';

export async function headerfulCachedRequest(query: string | DocumentNode, variables: any, jwId: Maybe<string>) {
	const headers: Record<string, string> = {
		'content-type': 'application/json',
		'App-Version': getAppVersion(),
	};

	// only add client headers if client is doing the request (SPA).
	// otherwise we could run in caching problems, as the headers are also taken into account for cache keys.
	if (import.meta.client) {
		const { X_RATE_LIMIT_SHORTCUT } = process.env;
		if (X_RATE_LIMIT_SHORTCUT) {
			headers['X-Rate-Limit-Shortcut'] = X_RATE_LIMIT_SHORTCUT;
		}

		if (jwId) {
			headers['Device-Id'] = jwId;
		}
	}

	try {
		const res = await getAxiosCached().request({
			method: 'POST',
			url: JW_CONFIG.GRAPHQL_URL,
			headers,
			data: { query: getQuery(query), variables },
		});

		return res.data;
	} catch (error: any) {
		captureMessageForSentry('core cached request failed', { error, where: 'request-helper.ts' }, 'error');

		// Re-throw so callers can handle the error appropriately
		throw error;
	}
}

function getQuery(query: string | DocumentNode): string {
	if ((query as DocumentNode).loc) {
		return (query as DocumentNode).loc?.source.body.replace(/[\s,]+/g, ' ').trim() || '';
	}

	return query as string;
}
